<div class="modal-header">
	<!-- <h3 class="modal-title">{{statusName}}</h3> -->
	<h3 class="modal-title">Detalle Causas</h3>
	<button type="button" class="close text-primary" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
		<i class="fas fa-times-circle"></i>
	</button>
</div>
<div class="modal-body scroll-dark-active">


	<ul class="nav nav-tabs" ngbNav #nav="ngbNav">
	<li [ngbNavItem]="1" class="nav-item" [class.active]="activeTabIds.includes(1)">
		<a ngbNavLink class="nav-link" (click)="setActiveTab(1)">{{type=='1raInstancia' ? '1ra Instancia' : 'Corte Apelaciones'}}</a>
		<ng-template ngbNavContent>

			<div class="container-fluid">
				<ng-container *ngIf="!searchingCauseData; else empty">
					<div class="card mb-2">
						<div class="card-body">
							<div *ngIf="!searchingCauseData" class="container">
								<div class="row mb-1">
									<div class="col-md-4">
										<span><strong>RIT :</strong> {{ selectedCause['data']['rit'] }}</span>
									</div>
									<div class="col-md-4" *ngFor="let item of headerInfo; let i = index">
										<span><strong>{{item.key}} :</strong> {{item.value}} </span>
									</div>
								</div>
							</div>
							<div *ngIf="searchingCauseData" class="container">
								<div class="row mb-1">
									<div class="col-md-3">
										<span><strong>Texto Exhorto:</strong></span>
										<div><i class="fas fa-folder fa-lg" style="color: #D7B926; cursor:pointer"></i></div>
									</div>
									<div class="col-md-3">
										<span><strong>Trámites:</strong></span>
										<div><i class="fas fa-ban fa-lg" style="color: #660000"></i></div>
									</div>
									<div class="col-md-3">
										<span><strong>Ebook:</strong></span>
										<div><a href="{{ selectedCause['attachments']?.ebook.link}}" target="_blank"><i
													class="far fa-file-pdf fa-lg" style="color: #660000"></i></a></div>
									</div>
									<div class="col-md-3">
										<span><strong>Certificado de Envío:</strong></span>
										<div><a href="#" target="_blank"><i class="far fa-file-pdf fa-lg"
													style="color: #660000"></i></a></div>
									</div>
								</div>
							</div>
							<div *ngIf="searchingCauseData" class="d-flex justify-content-center">
								<div class="spinner-border" role="status">
									<span class="sr-only">Loading...</span>
								</div>
							</div>
						</div>
					</div>
					<div class="card my-2" *ngIf="searchingCauseData">
						<div class="card-body">
							<div *ngIf="!searchingCauseData" class="container">
								<span><strong>Listado de Archivos de Audios de Audiencia</strong></span>
								<i class="fas fa-volume-up fa-2x ml-2" style="color: #6087FB"></i>
							</div>
							<div *ngIf="searchingCauseData" class="d-flex justify-content-center">
								<div class="spinner-border" role="status">
									<span class="sr-only">Loading...</span>
								</div>
							</div>
						</div>
					</div>
					<div class="card mt-2">
						<div class="card-body">
							<div *ngIf="searchingCauseData" class="d-flex justify-content-center">
								<div class="spinner-border" role="status">
									<span class="sr-only">Loading...</span>
								</div>
							</div>
							<div *ngIf="!searchingCauseData" class="container mt-4">
								<ul ngbNav class="nav nav-tabs" #contentNav="ngbNav" [(activeId)]="activeContentTab" class="nav-tabs">
									<li *ngFor="let tab of tableCause" [ngbNavItem]="tab.title">
										<a ngbNavLink>{{ tab.title }}</a>
										<ng-template ngbNavContent>
											<!-- Filtro por libro solo para movimientos -->
											<div class="row mb-3" *ngIf="uniqueBooks.length > 0 && tab.title == 'Movimientos'">
												<div class="col-md-4">
													<label for="bookFilter" class="form-label"><strong>Filtrar por Libro:</strong></label>
													<select
														class="form-control"
														id="bookFilter"
														[(ngModel)]="selectedBook"
														(change)="filterByBook()">
														<option value="">Todos los libros</option>
														<option *ngFor="let book of uniqueBooks" [value]="book">
															{{ book }}
														</option>
													</select>
												</div>
											</div>

											<table *ngIf="tab.title == 'Movimientos'"
												class="table table-bordered table-striped table-hover">
												<thead class="bg-secondary text-white">
													<tr>
														<th>Folio</th>
														<th>Doc.</th>
														<th>Libro</th>
														<th>Anexos</th>
														<th>Etapa</th>
														<th>Trámite</th>
														<th>Desc. Trámite</th>
														<th>Fecha Trámite</th>
														<th>Estado</th>
														<th>Georref.</th>
													</tr>
												</thead>
												<tbody>
													<ng-container *ngIf="tab.data.length > 0; else empty">
														<tr *ngFor="let row of tab.data">
															<td>{{ selectedCause['data'] && selectedCause['data'].competencieId == 5 ? '': row.invoice }}</td>
															<td>
																<ul
																	class="list-docs list-unstyled cursor-pointer m-0 d-flex align-items-center">
																	<li class="docs pull-up my-0 " placement="right"
																		[ngbTooltip]="doc.name"
																		*ngFor="let doc of row.CausesMovementsDocs; let key = index;">
																		<a attr.data-text="{{ doc.name }}" [href]="doc.url" class="link-doc"
																			target="_blank"></a>
																	</li>
																</ul>
															</td>
															<td>{{ row.book }}</td>
															<td>{{ row.attachments }}</td>
															<td>{{ row.stage }}</td>
															<td>{{ row.procedure }}</td>
															<td>{{ row.procedureDescription }}</td>
															<td>{{ row.processingDate }}</td>
															<td>{{ row.status }}</td>
															<td>{{ row.geogeo }}</td>
														</tr>
													</ng-container>
													<ng-template #empty>
														<tr>
															<td [attr.colspan]="9" class="text-center">
																No existen movimientos
															</td>
														</tr>
													</ng-template>
												</tbody>
											</table>
											<table *ngIf="tab.title == 'Litigantes'"
												class="table table-bordered table-striped table-hover">
												<thead class="bg-secondary text-white">
													<tr>
														<th>Est.</th>
														<th>Abog. Defensor</th>
														<th>Libro</th>
														<th>Sujeto</th>
														<th>Rut</th>
														<th>Persona</th>
														<th>Nombre o Razón Social</th>
													</tr>
												</thead>
												<tbody>
													<ng-container *ngIf="tab.data.length > 0; else empty">
														<tr *ngFor="let row of tab.data">
															<td><i class="far fa-check-square fa-lg" style="color: #2AB343"></i>
															</td>
															<td>{{ row.defenseAttorney }}</td>
															<td>{{ row.subject }}</td>
															<td>{{ row.book }}</td>
															<td>{{ row.identification }}</td>
															<td>{{ row.person }}</td>
															<td>{{ row.businessName }}</td>
														</tr>
													</ng-container>
													<ng-template #empty>
														<tr>
															<td [attr.colspan]="6" class="text-center">
																No existen litigantes
															</td>
														</tr>
													</ng-template>
												</tbody>
											</table>
											<table *ngIf="tab.title == 'Notificaciones'"
												class="table table-bordered table-striped table-hover">
												<thead class="bg-secondary text-white">
													<tr>
														<th>Estado Notif.</th>
														<th>RIT</th>
														<th>RUC</th>
														<th>Fecha Trámite</th>
														<th>Tipo Parte</th>
														<th>Nombre</th>
														<th>Trámite</th>
														<th>Obs. Fallida</th>
													</tr>
												</thead>
												<tbody>
													<ng-container *ngIf="tab.data.length > 0; else empty">
														<tr *ngFor="let row of tab.data">
															<td>{{ row.status }}</td>
															<td>{{ row.rit }}</td>
															<td>{{ row.ruc }}</td>
															<td>{{ row.procedure_date }}</td>
															<td>{{ row.part_type }}</td>
															<td>{{ row.name }}</td>
															<td>{{ row.procedure }}</td>
															<td>{{ row.failed_observation }}</td>
														</tr>
													</ng-container>
													<ng-template #empty>
														<tr>
															<td [attr.colspan]="8" class="text-center">
																No existen notificaciones
															</td>
														</tr>
													</ng-template>
												</tbody>
											</table>
											<table *ngIf="tab.title == 'Diligencias'"
												class="table table-bordered table-striped table-hover">
												<thead class="bg-secondary text-white">
													<tr>
														<th>Doc. Ida</th>
														<th>Doc. Vta.</th>
														<th>Estado Diligencia</th>
														<th>RIT</th>
														<th>RUC</th>
														<th>Tipo Diligencia</th>
														<th>Referencia</th>
														<th>Fecha Trámite</th>
													</tr>
												</thead>
												<tbody>
													<ng-container *ngIf="tab.data.length > 0; else empty">
														<tr *ngFor="let row of tab.data">
															<td>{{ row.departure_document }}</td>
															<td>{{ row.return_document }}</td>
															<td>{{ row.status }}</td>
															<td>{{ row.rit }}</td>
															<td>{{ row.ruc }}</td>
															<td>{{ row.type }}</td>
															<td>{{ row.reference }}</td>
															<td>{{ row.date }}</td>
														</tr>
													</ng-container>
													<ng-template #empty>
														<tr>
															<td [attr.colspan]="8" class="text-center">
																No existen diligencias
															</td>
														</tr>
													</ng-template>
												</tbody>
											</table>
											<table *ngIf="tab.title == 'Liquidación'"
												class="table table-bordered table-striped table-hover">
												<thead class="bg-secondary text-white">
													<tr>
														<th>Liquidación</th>
														<th>Rut</th>
														<th>Nombre</th>
														<th>Monto Líquido</th>
													</tr>
												</thead>
												<tbody>
													<ng-container *ngIf="tab.data.length > 0; else empty">
														<tr *ngFor="let row of tab.data">
															<td>{{ row.liquidation }}</td>
															<td>{{ row.rut }}</td>
															<td>{{ row.name }}</td>
															<td>{{ row.liquid_amount }}</td>
														</tr>
													</ng-container>
													<ng-template #empty>
														<tr>
															<td [attr.colspan]="4" class="text-center">
																No existen liquidación
															</td>
														</tr>
													</ng-template>
												</tbody>
											</table>
											<table *ngIf="tab.title == 'Materias'"
												class="table table-bordered table-striped table-hover">
												<thead class="bg-secondary text-white">
													<tr>
														<th>Código</th>
														<th>Glosa de Materia</th>
														<th>Estado</th>
														<th>Fecha Término</th>
													</tr>
												</thead>
												<tbody>
													<ng-container *ngIf="tab.data.length > 0; else empty">
														<tr *ngFor="let row of tab.data">
															<td>{{ row.code }}</td>
															<td>{{ row.gloss }}</td>
															<td>{{ row.status }}</td>
															<td>{{ row.end_date }}</td>
														</tr>
													</ng-container>
													<ng-template #empty>
														<tr>
															<td [attr.colspan]="4" class="text-center">
																No existen materias
															</td>
														</tr>
													</ng-template>
												</tbody>
											</table>
										</ng-template>
									</li>
								</ul>

								<div [ngbNavOutlet]="contentNav" class="mt-2"></div>
							</div>
						</div>
					</div>
				</ng-container>
				<ng-template #empty>
					<ng-container *ngIf="menssge1raInstancia === ''; else blockElse">
						<div class="d-flex justify-content-center align-items-center" style="height: calc(100vh - 280px);">
							<div class="spinner-border" role="status">
								<span class="sr-only">Loading...</span>
							</div>
						</div>
					</ng-container>
					<ng-template #blockElse>
						<div class="card border-0">
							<div class="card-body">
								<div class="container">

									<div class="row">
										<div class="col-md-12 text-center">
											<app-without-registration (click)="saveCauseRobotPjud()" [mostrarAction]="mostrarA"
												[textAction]="textA" [icon]="'fas fa-ban fa-lg'" [text]="menssge1raInstancia">
											</app-without-registration>
										</div>
									</div>

									<!-- Corregir datos y reintentar: cuando la causa no se conecta por datos erróneos
									     (RIT/tribunal/competencia), el cliente los corrige acá y reintenta. -->
									<div class="row mt-3" *ngIf="hasDataError && !correctionSaving">
										<div class="col-md-12 text-center" *ngIf="!showCorrection">
											<p class="text-muted small mb-2">
												¿Los datos de la causa son incorrectos? Puedes corregir el RIT, el tribunal o la
												competencia y volver a intentar la conexión.
											</p>
											<button type="button" class="btn btn-outline-primary btn-sm" (click)="openCorrection()">
												<i class="fas fa-edit mr-1"></i> Corregir datos y reintentar
											</button>
										</div>

										<div class="col-md-10 offset-md-1" *ngIf="showCorrection">
											<div class="card border">
												<div class="card-body text-left">
													<h6 class="mb-3"><i class="fas fa-edit mr-1"></i> Corregir datos de la causa</h6>
													<div class="form-row">
														<div class="form-group col-md-6">
															<label class="small font-weight-bold">RIT <span class="text-danger">*</span></label>
															<input type="text" class="form-control form-control-sm" [(ngModel)]="correction.rit"
																placeholder="Ej: C-1234-2024" />
														</div>
														<div class="form-group col-md-6">
															<label class="small font-weight-bold">Competencia <span class="text-danger">*</span></label>
															<select *ngIf="competencieOptions?.length" class="form-control form-control-sm"
																[(ngModel)]="correction.competencie">
																<option *ngFor="let c of competencieOptions" [value]="c">{{ c }}</option>
															</select>
															<input *ngIf="!competencieOptions?.length" type="text"
																class="form-control form-control-sm" [(ngModel)]="correction.competencie"
																placeholder="Ej: Juicio Civil Ejecutivo" />
														</div>
													</div>
													<div class="form-row">
														<div class="form-group col-md-6" *ngIf="correction.competencie !== 'Corte Apelaciones'">
															<label class="small font-weight-bold">Tribunal <span class="text-danger">*</span></label>
															<input type="text" class="form-control form-control-sm" [(ngModel)]="correction.tribunal"
																placeholder="Nombre del tribunal" />
														</div>
														<div class="form-group col-md-6" *ngIf="correction.competencie === 'Corte Apelaciones'">
															<label class="small font-weight-bold">Libro <span class="text-danger">*</span></label>
															<input type="text" class="form-control form-control-sm" [(ngModel)]="correction.book"
																placeholder="Libro (Corte de Apelaciones)" />
														</div>
													</div>
													<div class="text-right mt-2">
														<button type="button" class="btn btn-link btn-sm text-muted" (click)="cancelCorrection()">
															Cancelar
														</button>
														<button type="button" class="btn btn-primary btn-sm" [disabled]="!canSubmitCorrection"
															(click)="retryWithCorrection()">
															<i class="fas fa-sync-alt mr-1"></i> Guardar y reintentar
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div class="row mt-3" *ngIf="correctionSaving">
										<div class="col-md-12 text-center">
											<div class="spinner-border spinner-border-sm text-primary" role="status"></div>
											<span class="ml-2 small text-muted">Reintentando la conexión…</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-template>
				</ng-template>
			</div>

		</ng-template>
	</li>
	<li [ngbNavItem]="2" class="nav-item" *ngIf="type=='1raInstancia'" [class.active]="activeTabIds.includes(2)">
		<a ngbNavLink class="nav-link" (click)="setActiveTab(2)">Corte Apelaciones</a>
		<ng-template ngbNavContent>
			<h3 *ngIf="!recurso" class="text-center">
				Sin Recurso Asociado
			</h3>

			<div *ngIf="recurso" class="container-fluid">
				<ng-container *ngIf="!searchingCauseDataApelacion; else empty">
					<div class="card mb-2">
						<div class="card-body">
							<div *ngIf="!searchingCauseDataApelacion" class="container">
								<div class="row mb-1">
									<div class="col-md-4">
										<span><strong>RIT :</strong> {{ selectedCauseApelacion['data']['rit'] }}</span>
									</div>
									<div class="col-md-4" *ngFor="let item of headerInfoApelacion; let i = index">
										<span><strong>{{item.key}} :</strong> {{item.value}} </span>
									</div>
								</div>
							</div>
							<div *ngIf="searchingCauseDataApelacion" class="container">
								<div class="row mb-1">
									<div class="col-md-3">
										<span><strong>Texto Exhorto:</strong></span>
										<div><i class="fas fa-folder fa-lg" style="color: #D7B926; cursor:pointer"></i></div>
									</div>
									<div class="col-md-3">
										<span><strong>Trámites:</strong></span>
										<div><i class="fas fa-ban fa-lg" style="color: #660000"></i></div>
									</div>
									<div class="col-md-3">
										<span><strong>Ebook:</strong></span>
										<div><a href="{{ selectedCauseApelacion['attachments']?.ebook.link}}" target="_blank"><i
													class="far fa-file-pdf fa-lg" style="color: #660000"></i></a></div>
									</div>
									<div class="col-md-3">
										<span><strong>Certificado de Envío:</strong></span>
										<div><a href="#" target="_blank"><i class="far fa-file-pdf fa-lg"
													style="color: #660000"></i></a></div>
									</div>
								</div>
							</div>
							<div *ngIf="searchingCauseDataApelacion" class="d-flex justify-content-center">
								<div class="spinner-border" role="status">
									<span class="sr-only">Loading...</span>
								</div>
							</div>
						</div>
					</div>
					<div class="card my-2" *ngIf="searchingCauseDataApelacion">
						<div class="card-body">
							<div *ngIf="!searchingCauseDataApelacion" class="container">
								<span><strong>Listado de Archivos de Audios de Audiencia</strong></span>
								<i class="fas fa-volume-up fa-2x ml-2" style="color: #6087FB"></i>
							</div>
							<div *ngIf="searchingCauseDataApelacion" class="d-flex justify-content-center">
								<div class="spinner-border" role="status">
									<span class="sr-only">Loading...</span>
								</div>
							</div>
						</div>
					</div>
					<div class="card mt-2">
						<div class="card-body">
							<div *ngIf="searchingCauseDataApelacion" class="d-flex justify-content-center">
								<div class="spinner-border" role="status">
									<span class="sr-only">Loading...</span>
								</div>
							</div>
							<div *ngIf="!searchingCauseDataApelacion" class="container mt-4">
								<ul ngbNav class="nav nav-tabs" #contentNav="ngbNav" [(activeId)]="activeContentTab" class="nav-tabs">
									<li *ngFor="let tab of tableCauseApelacion" [ngbNavItem]="tab.title">
										<a ngbNavLink>{{ tab.title }}</a>
										<ng-template ngbNavContent>
											<!-- Filtro por libro solo para movimientos de apelaciones -->
											<div class="row mb-3" *ngIf="uniqueBooksApelacion.length > 0 && tab.title == 'Movimientos'">
												<div class="col-md-4">
													<label for="bookFilterApelacion" class="form-label"><strong>Filtrar por Libro:</strong></label>
													<select
														class="form-control"
														id="bookFilterApelacion"
														[(ngModel)]="selectedBookApelacion"
														(change)="filterByBookApelacion()">
														<option value="">Todos los libros</option>
														<option *ngFor="let book of uniqueBooksApelacion" [value]="book">
															{{ book }}
														</option>
													</select>
												</div>
											</div>

											<table *ngIf="tab.title == 'Movimientos'"
												class="table table-bordered table-striped table-hover">
												<thead class="bg-secondary text-white">
													<tr>
														<th>Folio</th>
														<th>Doc.</th>
														<th>Libro</th>
														<th>Anexos</th>
														<th>Etapa</th>
														<th>Trámite</th>
														<th>Desc. Trámite</th>
														<th>Fecha Trámite</th>
														<th>Estado</th>
														<th>Georref.</th>
													</tr>
												</thead>
												<tbody>
													<ng-container *ngIf="tab.data.length > 0; else empty">
														<tr *ngFor="let row of tab.data">
															<td>{{ row.invoice }}</td>
															<td>
																<ul
																	class="list-docs list-unstyled cursor-pointer m-0 d-flex align-items-center">
																	<li class="docs pull-up my-0 " placement="right"
																		[ngbTooltip]="doc.name"
																		*ngFor="let doc of row.CausesMovementsDocs; let key = index;">
																		<a attr.data-text="{{ doc.name }}" [href]="doc.url" class="link-doc"
																			target="_blank"></a>
																	</li>
																</ul>
															</td>
															<td>{{ row.book }}</td>
															<td>{{ row.attachments }}</td>
															<td>{{ row.stage }}</td>
															<td>{{ row.procedure }}</td>
															<td>{{ row.procedureDescription }}</td>
															<td>{{ row.processingDate }}</td>
															<td>{{ row.status }}</td>
															<td>{{ row.geogeo }}</td>
														</tr>
													</ng-container>
													<ng-template #empty>
														<tr>
															<td [attr.colspan]="9" class="text-center">
																No existen movimientos
															</td>
														</tr>
													</ng-template>
												</tbody>
											</table>
											<table *ngIf="tab.title == 'Litigantes'"
												class="table table-bordered table-striped table-hover">
												<thead class="bg-secondary text-white">
													<tr>
														<th>Est.</th>
														<th>Abog. Defensor</th>
														<th>Libro</th>
														<th>Sujeto</th>
														<th>Rut</th>
														<th>Persona</th>
														<th>Nombre o Razón Social</th>
													</tr>
												</thead>
												<tbody>
													<ng-container *ngIf="tab.data.length > 0; else empty">
														<tr *ngFor="let row of tab.data">
															<td><i class="far fa-check-square fa-lg" style="color: #2AB343"></i>
															</td>
															<td>{{ row.defenseAttorney }}</td>
															<td>{{ row.subject }}</td>
															<td>{{ row.book }}</td>
															<td>{{ row.identification }}</td>
															<td>{{ row.person }}</td>
															<td>{{ row.businessName }}</td>
														</tr>
													</ng-container>
													<ng-template #empty>
														<tr>
															<td [attr.colspan]="6" class="text-center">
																No existen litigantes
															</td>
														</tr>
													</ng-template>
												</tbody>
											</table>
											<table *ngIf="tab.title == 'Notificaciones'"
												class="table table-bordered table-striped table-hover">
												<thead class="bg-secondary text-white">
													<tr>
														<th>Estado Notif.</th>
														<th>RIT</th>
														<th>RUC</th>
														<th>Fecha Trámite</th>
														<th>Tipo Parte</th>
														<th>Nombre</th>
														<th>Trámite</th>
														<th>Obs. Fallida</th>
													</tr>
												</thead>
												<tbody>
													<ng-container *ngIf="tab.data.length > 0; else empty">
														<tr *ngFor="let row of tab.data">
															<td>{{ row.status }}</td>
															<td>{{ row.rit }}</td>
															<td>{{ row.ruc }}</td>
															<td>{{ row.procedure_date }}</td>
															<td>{{ row.part_type }}</td>
															<td>{{ row.name }}</td>
															<td>{{ row.procedure }}</td>
															<td>{{ row.failed_observation }}</td>
														</tr>
													</ng-container>
													<ng-template #empty>
														<tr>
															<td [attr.colspan]="8" class="text-center">
																No existen notificaciones
															</td>
														</tr>
													</ng-template>
												</tbody>
											</table>
											<table *ngIf="tab.title == 'Diligencias'"
												class="table table-bordered table-striped table-hover">
												<thead class="bg-secondary text-white">
													<tr>
														<th>Doc. Ida</th>
														<th>Doc. Vta.</th>
														<th>Estado Diligencia</th>
														<th>RIT</th>
														<th>RUC</th>
														<th>Tipo Diligencia</th>
														<th>Referencia</th>
														<th>Fecha Trámite</th>
													</tr>
												</thead>
												<tbody>
													<ng-container *ngIf="tab.data.length > 0; else empty">
														<tr *ngFor="let row of tab.data">
															<td>{{ row.departure_document }}</td>
															<td>{{ row.return_document }}</td>
															<td>{{ row.status }}</td>
															<td>{{ row.rit }}</td>
															<td>{{ row.ruc }}</td>
															<td>{{ row.type }}</td>
															<td>{{ row.reference }}</td>
															<td>{{ row.date }}</td>
														</tr>
													</ng-container>
													<ng-template #empty>
														<tr>
															<td [attr.colspan]="8" class="text-center">
																No existen diligencias
															</td>
														</tr>
													</ng-template>
												</tbody>
											</table>
											<table *ngIf="tab.title == 'Liquidación'"
												class="table table-bordered table-striped table-hover">
												<thead class="bg-secondary text-white">
													<tr>
														<th>Liquidación</th>
														<th>Rut</th>
														<th>Nombre</th>
														<th>Monto Líquido</th>
													</tr>
												</thead>
												<tbody>
													<ng-container *ngIf="tab.data.length > 0; else empty">
														<tr *ngFor="let row of tab.data">
															<td>{{ row.liquidation }}</td>
															<td>{{ row.rut }}</td>
															<td>{{ row.name }}</td>
															<td>{{ row.liquid_amount }}</td>
														</tr>
													</ng-container>
													<ng-template #empty>
														<tr>
															<td [attr.colspan]="4" class="text-center">
																No existen liquidación
															</td>
														</tr>
													</ng-template>
												</tbody>
											</table>
											<table *ngIf="tab.title == 'Materias'"
												class="table table-bordered table-striped table-hover">
												<thead class="bg-secondary text-white">
													<tr>
														<th>Código</th>
														<th>Glosa de Materia</th>
														<th>Estado</th>
														<th>Fecha Término</th>
													</tr>
												</thead>
												<tbody>
													<ng-container *ngIf="tab.data.length > 0; else empty">
														<tr *ngFor="let row of tab.data">
															<td>{{ row.code }}</td>
															<td>{{ row.gloss }}</td>
															<td>{{ row.status }}</td>
															<td>{{ row.end_date }}</td>
														</tr>
													</ng-container>
													<ng-template #empty>
														<tr>
															<td [attr.colspan]="4" class="text-center">
																No existen materias
															</td>
														</tr>
													</ng-template>
												</tbody>
											</table>
										</ng-template>
									</li>
								</ul>

								<div [ngbNavOutlet]="contentNav" class="mt-2"></div>
							</div>
						</div>
					</div>
				</ng-container>
				<ng-template #empty>
					<ng-container *ngIf="recurso; else blockElse">
						<div class="d-flex justify-content-center align-items-center" style="height: calc(100vh - 280px);">
							<div class="spinner-border" role="status">
								<span class="sr-only">Loading...</span>
							</div>
						</div>
					</ng-container>
					<ng-template #blockElse>
						<div class="card border-0">
							<div class="card-body">
								<div class="container">

									<div class="row">
										<div class="col-md-12 text-center">
											<app-without-registration (clickk)="saveCauseRobotPjudApelacion()" [mostrarAction]="mostrarA"
												[textAction]="textA" [icon]="'fas fa-ban fa-lg'" [text]="menssgeApelacion">
											</app-without-registration>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-template>
				</ng-template>
			</div>

		</ng-template>
	</li>
	</ul>
	<div [ngbNavOutlet]="nav" class="mt-2"></div>

</div>